import {
  BrowserRouter,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";

import ProtectedRoutes from "./ProtectedRoutes";
import PublicRoutes from "./PublicRoutes";
import PermissionDenied from "./PermissionDenied";
import InnerContent from "./InnerContent";
import NoPage from "../pages/NoPage";

import Login from "../pages/Login";
import Chamados from "../pages/Chamados";
import Historico from "../pages/Historico";
import Dashboard from "../pages/Dashboard";
import Direcionamento from "../pages/Direcionamento";
import Calendario from "../pages/Calendario";
import VisualizarTask from "../pages/visualizarTask"
import TarefasAdd from "../pages/TarefasAdd"
import TarefasEdit from "../pages/TarefasEdit"
import RedirectHome from "./RedirectHome";

export const Router = () => {
  return (
    <BrowserRouter>
      <Routes>
        {/* Rotas Protegidas */}
        <Route path="/" element={<ProtectedRoutes />}>
          <Route path="/" element={<InnerContent />}>
           <Route path="/" element={<RedirectHome />} />
            <Route path="task" element={<Chamados />} />
            <Route path="history" element={<Historico />} />
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="assignment" element={<Direcionamento />} />
            <Route path="calendar" element={<Calendario />} />
             <Route element={<ProtectedRoutes roleRequired="Tarefas" />}>
              <Route path="/task/add" element={<TarefasAdd/>} />
            </Route>
            <Route element={<ProtectedRoutes roleRequired="Tarefas" />}>
              <Route path="/task/edit/:id" element={<TarefasEdit/>} />
            </Route>

          </Route>
        </Route>

        {/* Rotas Públicas */}
        <Route path="login" element={<PublicRoutes />}>
          <Route path="/login" element={<Login />} />
          <Route path="/login" element={<Login />} />
        

        </Route>
        <Route path="report/:company/:token/:id" element={<VisualizarTask />} />
        {/* Rota Não Protegida para Chamados */}
        <Route path="/:modo/:entidade/:qrcode" element={<Login />} />

        {/* Outras Rotas */}
        <Route path="/denied" element={<PermissionDenied />} />
        <Route path="*" element={<NoPage />} />
      </Routes>
    </BrowserRouter>
  );
};

export default Router;
